/* eslint-disable max-len */
import { defineMessages } from 'react-intl';

const messages = defineMessages({
  title: {
    id: 'App.ViewProperty.AffordableSetup.Programs.HUD.DeleteContractModal.title',
    defaultMessage: 'Delete this contract?',
  },
  confirmationText: {
    id: 'App.ViewProperty.AffordableSetup.Programs.HUD.DeleteContractModal.confirmationText',
    defaultMessage:
      'Deleting this contract will remove it from all assigned units. Those units will no longer have a contract assigned.',
  },
  warningBanner: {
    id: 'App.ViewProperty.AffordableSetup.Programs.HUD.DeleteContractModal.warningBanner',
    defaultMessage:
      'You must assign a new contract to all affected units to ensure certifications and voucher processing remain accurate.',
  },
  cancel: {
    id: 'App.ViewProperty.AffordableSetup.Programs.HUD.DeleteContractModal.cancel',
    defaultMessage: 'Cancel',
  },
  confirm: {
    id: 'App.ViewProperty.AffordableSetup.Programs.HUD.DeleteContractModal.confirm',
    defaultMessage: 'Confirm',
  },
});

export default messages;
